import React from 'react'
import {Link} from 'react-router-dom'
import './HomeComponent.css'

function HomeComponent() {
  return (
    <>
      <section id='hero-banner'>
          <div className='banner-inner'>
          <div class="container">
              <div class="row">
              <div class="col-sm-12">
                <h2>Stronger than <b>EVER</b></h2>
                <p>Welcome to the world of Badminton where learning is fun.</p>
                  <Link to='/bookings' className="btn btn-primary btn-lg" >
                      Book Now
                  </Link>
                {/* <a class="btn btn-primary btn-lg" href="#booking">Book Now</a>                 */}
              </div>
              </div>
          </div>
          </div>
      </section>
      
    </>
  )
}

export default HomeComponent